import { useState } from 'react';

import { SectionTitle } from '../../Pages/Auth/Practitioners/components/HowWeWorkSection/styles';
import FaqItem from '../FaqItem';
import CTAButton from '../../ui/ctaButton';

import { FAQ_DATA, FAQ_CONTENT } from './constants';
import { openSimplePracticeConsultation } from '../../utils/simplePractice';

import { HeaderBox, FaqItemsWrapper, CtaWrapper } from './styles';
import { Box } from '@mui/material';

const FaqQuickList = () => {
  const [expanded, setExpanded] = useState(null);

  const handleToggle = (index) => () => {
    setExpanded(expanded === index ? null : index);
  };

  const handleCtaClick = () => {
    openSimplePracticeConsultation();
  };

  return (
    <Box>
      <HeaderBox>
        <SectionTitle align="center">{FAQ_CONTENT.title}</SectionTitle>
      </HeaderBox>

      <FaqItemsWrapper>
        {FAQ_DATA.map((faq, index) => (
          <FaqItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isExpanded={expanded === index}
            onToggle={handleToggle(index)}
          />
        ))}
      </FaqItemsWrapper>
      <CtaWrapper>
        <CTAButton variant="contained" text={FAQ_CONTENT.buttonText} onClick={handleCtaClick} />
      </CtaWrapper>
    </Box>
  );
};

export default FaqQuickList;
